export default {
  name: 'table-column-text',
  props: {
    text: {
      type: String,
      default: ''
    },
    stylingClasses: {
      type: Array,
      default: []
    }
  },
  data () {
    return {

    }
  }
}
